module.exports = __webpack_public_path__ + "static/zwartgoude-jurk-1-7e7ab99cb41ddcab6fa2e351800aaca9.jpg";